import { EMPTY_STRING, NUMBER_FORMAT_LOCALE } from '../constants/common'

/**
 * @param {number} dividend
 * @param {number} divisor
 *
 * @returns {number}
 */
export function mod(dividend, divisor) {
  if (Number.isSafeInteger(dividend)) {
    if (Number.isSafeInteger(divisor) && divisor !== 0) {
      return ((dividend % divisor) + divisor) % divisor
    }

    throw new Error(
      'mod: the `divisor` param should be a non-zero safe integer'
    )
  }

  throw new Error('mod: the `dividend` param should be a safe integer')
}

/**
 * @param {number} number
 * @param {number} divisor
 *
 * @returns {[number, number]}
 */
export function divMod(number, divisor) {
  const module = mod(number, divisor)

  return [(number - module) / divisor, module]
}

/**
 * Formats a number using thousand separators.
 *
 * The output uses dots as thousand separators (e.g. 1.000.000),
 * following a European number format.
 *
 * Use this helper instead of calling `toLocaleString` directly
 * to keep number formatting consistent across the project.
 *
 * Pass `options` (an `Intl.NumberFormat` options object) to control
 * fraction digits, e.g. `{ minimumFractionDigits: 2, maximumFractionDigits: 2 }`
 * for money.
 */
export function formatNumberWithSeparators(value, options) {
  if (value == null) {
    return EMPTY_STRING
  }

  const numberValue = Number(value)

  if (Number.isNaN(numberValue)) {
    return EMPTY_STRING
  }

  return numberValue.toLocaleString(NUMBER_FORMAT_LOCALE, options)
}

/**
 * Compared numerically: `String(value)` switches to exponent form for small numbers.
 */
export function hasMaxDecimalPlaces(value, maxDecimalPlaces) {
  return value == null || Number(value.toFixed(maxDecimalPlaces)) === value
}

/**
 * Parses a number entered with a comma or dot decimal separator to a number.
 */
export function parseAmount(value) {
  return Number(String(value).replace(',', '.'))
}
